// ======================= US States List =======================
export const NewYorkStates = [
  { label: "Alabama (AL)", value: "AL" },
  { label: "Alaska (AK)", value: "AK" },
  { label: "Arizona (AZ)", value: "AZ" },
  { label: "Arkansas (AR)", value: "AR" },
  { label: "California (CA)", value: "CA" },
  { label: "Colorado (CO)", value: "CO" },
  { label: "Connecticut (CT)", value: "CT" },
  { label: "Delaware (DE)", value: "DE" },
  { label: "Florida (FL)", value: "FL" },
  { label: "Georgia (GA)", value: "GA" },
  { label: "Hawaii (HI)", value: "HI" },
  { label: "Idaho (ID)", value: "ID" },
  { label: "Illinois (IL)", value: "IL" },
  { label: "Indiana (IN)", value: "IN" },
  { label: "Iowa (IA)", value: "IA" },
  { label: "Kansas (KS)", value: "KS" },
  { label: "Kentucky (KY)", value: "KY" },
  { label: "Louisiana (LA)", value: "LA" },
  { label: "Maine (ME)", value: "ME" },
  { label: "Maryland (MD)", value: "MD" },
  { label: "Massachusetts (MA)", value: "MA" },
  { label: "Michigan (MI)", value: "MI" },
  { label: "Minnesota (MN)", value: "MN" },
  { label: "Mississippi (MS)", value: "MS" },
  { label: "Missouri (MO)", value: "MO" },
  { label: "Montana (MT)", value: "MT" },
  { label: "Nebraska (NE)", value: "NE" },
  { label: "Nevada (NV)", value: "NV" },
  { label: "New Hampshire (NH)", value: "NH" },
  { label: "New Jersey (NJ)", value: "NJ" },
  { label: "New Mexico (NM)", value: "NM" },
  { label: "New York (NY)", value: "NY" },
  { label: "North Carolina (NC)", value: "NC" },
  { label: "North Dakota (ND)", value: "ND" },
  { label: "Ohio (OH)", value: "OH" },
  { label: "Oklahoma (OK)", value: "OK" },
  { label: "Oregon (OR)", value: "OR" },
  { label: "Pennsylvania (PA)", value: "PA" },
  { label: "Rhode Island (RI)", value: "RI" },
  { label: "South Carolina (SC)", value: "SC" },
  { label: "South Dakota (SD)", value: "SD" },
  { label: "Tennessee (TN)", value: "TN" },
  { label: "Texas (TX)", value: "TX" },
  { label: "Utah (UT)", value: "UT" },
  { label: "Vermont (VT)", value: "VT" },
  { label: "Virginia (VA)", value: "VA" },
  { label: "Washington (WA)", value: "WA" },
  { label: "West Virginia (WV)", value: "WV" },
  { label: "Wisconsin (WI)", value: "WI" },
  { label: "Wyoming (WY)", value: "WY" },
];
/**
 * An array containing the full names of all twelve months in the Gregorian calendar,
 * starting from "January" at index 0 to "December" at index 11.
 *
 * @type {string[]}
 * @constant
 * @example
 * // Get the name of the 5th month (May)
 * const may = monthNames[4]; // "May"
 */
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
// ======================= FedEx Delivery Options =======================
export const deliveryFedEx = [
  { name: "None", value: "none" },
  { name: "Delivery", value: "delivery" },
  { name: "Signature", value: "signature" },
  { name: "Direct_Signature", value: "direct_signature" },
  { name: "Adult_Signature", value: "adult_signature" },
];
export const templatePersonalDetailsOptions = [
  {
    label: "First Name",
    value: "firstName",
  },
  {
    label: "Last Name",
    value: "lastName",
  },

  {
    label: "Middle Name",
    value: "middleName",
  },
  {
    label: "Enrollment ID",
    value: "enrollmentId",
  },
  {
    label: "Account ID",
    value: "accountId",
  },
  {
    label: "PO BOX",
    value: "poBox",
  },
  {
    label: "Mailing State",
    value: "mailingState",
  },
  {
    label: "Mailing City",
    value: "mailingCity",
  },
  {
    label: "State",
    value: "state",
  },
  {
    label: "City",
    value: "city",
  },
  {
    label: "Mailing Address 1",
    value: "mailingAddress1",
  },
  {
    label: "Mailing Address 2",
    value: "mailingAddress2",
  },
  {
    label: "Zip Code",
    value: "zipCode",
  },
  {
    label: "Address 1",
    value: "address1",
  },
  {
    label: "Alternate Contact",
    value: "alternateContact",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Contact",
    value: "contact",
  },
  {
    label: "DOB",
    value: "dob",
  },

  {
    label: "Suffix",
    value: "suffix",
  },
  {
    label: "SSN",
    value: "ssn",
  },
];
export const templateDateParametersOptions = [
  {
    label: "Label Print Date",
    value: "labelPrintDate",
  },
  {
    label: "Plan Activation Date",
    value: "planActivationDate",
  },
  {
    label: "Package Delivery Date",
    value: "packageDeliveryDate",
  },
  {
    label: "Plan Expiration Date",
    value: "planExpirationDate",
  },
  {
    label: "Account Activation Date",
    value: "accountActivationDate",
  },
  {
    label: "Order Create Date",
    value: "orderCreateDate",
  },
  {
    label: "Approval Date",
    value: "approvalDate",
  },
  {
    label: "Rejection Date",
    value: "rejectionDate",
  },
  {
    label: "ESN Assignment Date",
    value: "esnAssignDate",
  },
  {
    label: "Label Create Date",
    value: "labelCreateDate",
  },
  {
    label: "Invoice Create Date",
    value: "invoiceCreateDate",
  },
  {
    label: "Invoice Adjustment Date",
    value: "invoiceAdjustmentDate",
  },
  {
    label: "Invoice Voided Date",
    value: "invoiceVoidedDate",
  },
  {
    label: "Ad HOC Invoice Date",
    value: "adHocInvoiceDate",
  },
  {
    label: "ESN Activation Date",
    value: "esnActivationDate",
  },
  {
    label: "Plan Configured Date",
    value: "planConfiguredDate",
  },
  {
    label: "Disconnection Date",
    value: "disconnectionDate",
  },
  {
    label: "Disconnection Reason",
    value: "disconnectionReason",
  },
];
export const templatePlanInfoOptions = [
  {
    label: "IMEI Number",
    value: "imei",
  },
  {
    label: "PWG Customer ID",
    value: "pwgCustomerId",
  },
  {
    label: "Carrier",
    value: "carrier",
  },
  {
    label: "Line Status",
    value: "lineStatus",
  },

  {
    label: "MDN",
    value: "mdn",
  },
  {
    label: "Plan Name",
    value: "planName",
  },
  {
    label: "Plan Code",
    value: "planCode",
  },
  {
    label: "ESN Number",
    value: "esnNumber",
  },
];
export const templateMiscallenousOptions = [
  {
    label: "Sale Created By",
    value: "saleCreatedBy",
  },
  {
    label: "Sale Completed By",
    value: "saleCompletedBy",
  },
  {
    label: "ESN Assigned By",
    value: "esnAssignedBy",
  },
  {
    label: "ESN Activated By",
    value: "esnActivatedBy",
  },
  {
    label: "Invoice Generated By",
    value: "invoiceGeneratedBy",
  },
  {
    label: "Invoice Paid By",
    value: "invoicePaidBy",
  },
  {
    label: "Invoice Void By",
    value: "invoiceVoidedBy",
  },
  {
    label: "Invoice Adjusted By",
    value: "invoiceAdjustedBy",
  },
  {
    label: "AdHoc Invoice Added By",
    value: "adHocInvoiceAddedBy",
  },
  {
    label: "Label Created By",
    value: "labelCreatedBy",
  },
  {
    label: "Label Printed By",
    value: "labelPrintedBy",
  },
  {
    label: "Package Delivered By",
    value: "packageDeliveredBy",
  },
  {
    label: "Account Activated By",
    value: "accountActivatedBy",
  },
  {
    label: "Plan Activated By",
    value: "planActivatedBy",
  },
  {
    label: "Plan Configured By",
    value: "planConfiguredBy",
  },
  {
    label: "Plan Chnaged By",
    value: "planChangedBy",
  },
  {
    label: "Disconnected By",
    value: "disconnectedBy",
  },
];
